export const ProjectSelector = ({ projects, allBoard, compact, ...props }) => {

    const defaultProject = { id: null, name: "None" };

    const selectedProject = props.selectedProject && Object.hasOwn(props.selectedProject, "name") ?
        props.selectedProject :
        projects.find(project => project.id === props.selectedProject) || defaultProject;

    return selectedProject ? (

        <div className={compact ? "" : "mb-3 d-md-flex fw-bold"}>
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }} data-bs-toggle="dropdown" className="text-decoration-none text-dark fs-5">
                    <i className={`${selectedProject.id === 'all' ? 'fas fa-layer-group' : 'far fa-folder'} fa-fw text-dark text-opacity-50 me-1`}></i> 
                    {selectedProject.name} 
                    <b className="ms-5px caret"></b>
                </div>

                <div className="dropdown-menu dropdown-menu-start">
                    {allBoard && (
                        <>
                            <div onClick={() => props.onProjectSelect(allBoard)} style={{ cursor: "pointer" }} className="dropdown-item fs-5"><i className="fas fa-layer-group fa-fw fa-lg text-gray-500 me-1"></i>All</div>
                            <div className="dropdown-divider"></div>
                        </>
                    )}

                    {projects.map(project => ( // For each project...
                        <div onClick={() => props.onProjectSelect(project)} style={{ cursor: "pointer" }} key={project.id} className="dropdown-item fs-5"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i>{project.name}</div>

                    ))}

                    <div onClick={() => props.handleNewProjectClick()} style={{ cursor: "pointer" }} className="dropdown-item fs-5"><i className="far fa-plus fa-fw fa-lg text-gray-500 me-1"></i> ... Add New Board ...</div>

                </div>
            </div>
        </div>

    )
        :
        (<>Loading...</>);

}